// @flow
import { connect } from 'react-redux'
import ProvidersSet from './ProvidersSet'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    providers: audienceState.providers,
    providersInfo: audienceState.providersInfo,
    errors: audienceState.providersErrors
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: Object) {
  return {
    onChange: (value: Array<string>) => {
      patch(dispatch, { providers: value })
      ownProps.onChange && ownProps.onChange()
    }
  }
}

const ProvidersSetContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(ProvidersSet)

export default ProvidersSetContainer
